import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Menu";
import Contact from "./pages/Contact";
import Career from "./pages/Career";

import Navbar from "./components/Nav";
import Footer from "./components/Footer";

import LoadingScreen from "./pages/LoadingScreen";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 4000); // 2 sec loading
  }, []);

  // FIRST RETURN -> Loading Screen
  if (loading) {
    return <LoadingScreen />;
  }

  // SECOND RETURN -> Main Website
  return (
    <div>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/menu" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Career />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
